import React, { Component } from "react"
import { Index } from "elasticlunr"
import { Link } from "gatsby"
import searchIcon from "../images/search.png";
import './search.css';
import searchGraphic from "../images/search_graphic.jpg";

// Search component
export default class Search extends Component {
  constructor(props) {
    super(props)
    this.state = {
      query: ``,
      results: [],
    }
  }

  render() {
    return (
      <div>
        <div style={{
            width: '100%',
            marginBottom: '20px',
            display: 'flex',
            height: '40px'
        }}>
            <div style={{
                display:'flex',
                border: '1px solid hsla(0, 0%, 0%, 0.8)',
                borderRadius: '4px',
                paddingRight:'4px'
            }}>
            <img style={{
            width: '40px',
            padding: '8px',
            marginBottom: '0px'
        }} src={searchIcon} alt="search"></img>
            <input
            className="searchInput"
        style={{
            border: '0px'
        }}
        type="text" value={this.state.query} onChange={this.search} />
        </div>
        </div>
          {
              ((this.state.results.length === 0 && this.state.query !== ``) && <>
              <div
              className="searchMessage"
              style={{
                  marginBottom: '0px',
              }}>Nessun risultato trovato.
              <img className="searchGraphic" src={searchGraphic} alt="search graphic"></img>
              </div>
              </>)
          }
          {
              ((this.state.results.length === 0 && this.state.query === ``) && <>
              <div
              className="searchMessage"
              style={{
                  marginBottom: '0px'
              }}>Inizia a digitare per avviare la ricerca.
              <img className="searchGraphic" src={searchGraphic} alt="search graphic"></img>
              </div>
              </>)
          }
          {this.state.results.slice(0,7).map(page => (
            <div key={page.id}>
              <Link to={"/post/" + page.slug} style={{
                  color: "hsla(0, 0%, 0%, 0.8)",
                  textDecoration: 'none',
                  maxWidth: 720
              }}>
              <div className="articleContent" style={{paddingLeft: 0, marginTop:20}}>
              <h3 className="articlePrevTitle">{page.title}</h3>
              <div className="articlePrevText">
                <div className="textContainer" style={{
                    "webkitBoxOrient": "vertical",
                    maxWidth: '100%'}}>
                    {page.content.substring(0,400)}
                </div>
              </div>
              </div>
              </Link>
              <div style={{
                  textTransform: 'uppercase',
                  cursor: 'pointer',
                  fontFamily: 'oswald_regular',
                  fontSize: '16px',
                  marginTop: '4px'
              }}>{ page.tags.join(`,`)}</div>
              
            </div>
          ))}
      </div>
    )
  }
  getOrCreateIndex = () =>
    this.index
      ? this.index
      : // Create an elastic lunr index and hydrate with graphql query results
        Index.load(this.props.searchIndex)
/*
  search = evt => {
    const query = evt.target.value
    this.index = this.getOrCreateIndex()
    this.setState({
      query,
      // Query the index with search string to get an [] of IDs
      results: this.index
        .search(query, {})
        // Map over each ID and return the full document
        .map(({ ref }) => this.index.documentStore.getDoc(ref)),
    })
    
  }
  */
  search = evt => {
    const query = evt.target.value
    this.index = this.getOrCreateIndex()
    this.setState({
      query,
      // Query the index with search string to get an [] of IDs
      results: this.index
        .search(query, { expand: true }) // Accept partial matches
        // Map over each ID and return the full document
        .map(({ ref }) => this.index.documentStore.getDoc(ref)),
    })
  }
}
